const formatVietnameseDays = (nameOfDay: string): string => {
  switch (nameOfDay) {
  case 'Thứ Hai':
    return 'T2';
  case 'Thứ Ba':
    return 'T3';
  case 'Thứ Tư':
    return 'T4';
  case 'Thứ Năm':
    return 'T5';
  case 'Thứ Sáu':
    return 'T6';
  case 'Thứ Bảy':
    return 'T7';
  case 'Chủ Nhật':
    return 'CN';
  default:
    return '';
  }
};

const formatThaiDays = (nameOfDay: string): string => {
  switch (nameOfDay) {
  case 'อาทิตย์':
    return 'อา';
  case 'จันทร์':
    return 'จ';
  case 'อังคาร':
    return 'อ';
  case 'พุธ':
    return 'พ';
  case 'พฤหัสบดี':
    return 'พฤ';
  case 'ศุกร์':
    return 'ศ';
  case 'เสาร์':
    return 'ส';
  default:
    return '';
  }
};

export const formatNameOfDay = (nameOfDay: string, locale: string): string => {
  switch (locale) {
  case 'th-TH':
    // custom logic since days are abbreviated differently
    return formatThaiDays(nameOfDay);
  case 'vi-VN':
    // custom logic since days are abbreviated differently
    return formatVietnameseDays(nameOfDay);
  case 'ja-JP':
    // 1 symbol
    return nameOfDay.substr(0, 1);
  default:
    return nameOfDay.substr(0, 3);
  }
};
